export class PageGenericActionItem {}
